type DataBlockType = {
  category: string;
  collected: string[];
  sources: string[];
};

const generateDataBlock = (descriptor: DataBlockType) => (
  <tr>
    <td className="border border-gray-200 p-2 font-bold">
      {descriptor.category}
    </td>
    <td className="border border-gray-200 p-2">
      <ol className="ml-3 mt-1 list-disc">
        {descriptor.collected.map((collectedData) => (
          <li className="mb-1">{collectedData}</li>
        ))}
      </ol>
    </td>
    <td className="border border-gray-200 p-2">
      <ol className="ml-3 mt-1 list-disc">
        {descriptor.sources.map((sourceData) => (
          <li className="mb-1">{sourceData}</li>
        ))}
      </ol>
    </td>
  </tr>
);

const thirdPartyServicesDescriptors: DataBlockType[] = [
  {
    category: 'Identifiers',
    collected: [
      'First name',
      'Last name',
      'Password (encrypted)',
      'Profile picture',
      'Internet Protocol address(es)',
      'Email address',
      'Account name (username), or other similar identifier',
      'Telephone number',
      'Mobile push tokens',
      'Specific third-party identifiers relating to payment services (VAT, Tax Identification Number) may be collected for some accounts',
    ],
    sources: [
      'Information you provide us',
      'Information we collect from you automatically',
      '3rd Party Service Provider',
    ],
  },
  {
    category: 'Geolocation Data',
    collected: [
      'IP address data',
      'Location',
      'Physical address',
      'Country',
      'Postal code/Zipcode',
      'Timezone',
    ],
    sources: [
      'Information you provide us',
      'Information we collect from you automatically',
    ],
  },
  {
    category: 'User profile',
    collected: [
      'Gender',
      'Age',
      'Language',
      'Content Language',
      'Other information the User chooses to share in the private section of the profile',
    ],
    sources: [
      'Information you provide us',
      'Information we collect from you automatically',
      '3rd Party Service Provider',
    ],
  },
  {
    category: 'User activities',
    collected: [
      'Favorites',
      'Chat messages',
      'Appointment details (location, time, status)',
      'Appointments history',
    ],
    sources: [
      'Information you provide us',
      'Information we collect from you automatically',
    ],
  },
  {
    category: 'Advertiser profile',
    collected: [
      'Business Profiles name',
      'Business Profiles phone number',
      'Business Profiles location (address, location, country)',
      'Business Profiles hours',
      'Business Profiles services (name, duration, price, availability)',
      'Other information the Advertiser chooses to share in the private section of the Business Profile',
      'Other information the Advertiser chooses to share in the private section of the Advertiser Profile',
    ],
    sources: [
      'Information you provide us',
      'Information we collect from you automatically',
      '3rd Party Service Provider',
    ],
  },
  {
    category: 'Payments',
    collected: [
      'First name',
      'Last name',
      'Account ID',
      'Email address',
      'Transaction ID',
      'Transaction timestamps',
      'Transaction amount',
      'Transaction status',
    ],
    sources: [
      'Information you provide us',
      'Information we collect from you automatically',
      '3rd Party Service Provider',
    ],
  },
  {
    category: 'Internet or other similar network activity',
    collected: [
      'Browsing history',
      'Information on a User’s interaction with the Services',
      'Information regarding your operating system and device',
    ],
    sources: [
      'Information we collect from you automatically',
      '3rd Party Service Provider',
    ],
  },
];

const CollectedDataGrid = () =>
  thirdPartyServicesDescriptors.length > 0 ? (
    <div className="w-full">
      <div className="py-2">
        <div className="mt-4 rounded-lg border-2 border-solid border-gray-200 text-sm">
          <table className="w-full table-auto border-collapse border border-gray-200 text-center">
            <thead>
              <tr className="border border-gray-100 bg-gray-200">
                <th className="border border-gray-200  p-2">
                  Personal Data Category
                </th>
                <th className="border border-gray-200  p-2">
                  Personal Data we collect in this Category
                </th>
                <th className="border border-gray-200  p-2">
                  Sources of Personal Data
                </th>
              </tr>
            </thead>
            <tbody className="text-left">
              {thirdPartyServicesDescriptors.map((descriptor) =>
                generateDataBlock(descriptor),
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  ) : null;
export default CollectedDataGrid;
